export default __webpack_public_path__ + "static/media/send_Diagram.c928f385.gif";